const masksArr = [
  ['yyyy', 'fullYear'], // 年 0000
  ['mm', 'month'],   // 月 00
  ['m', 'month'],   // 月 00
  ['dd', 'date'],   // 日 00
  ['d', 'date'],   // 日 0
  ['HH', 'hours'], // 时 00
  ['H', 'hours'], // 时 0
  ['MM', 'minutes'], // 分 00
  ['M', 'minutes'], // 分 0
  ['SS', 'seconds'], // 00
  ['S', 'seconds'] // 0
]
const masks = new Map(masksArr)
class DateFormat {
  constructor(date) {
    this._date = new Date(date)
  }
  formatNumber(num) {
    return num < 10 ? `0${num}` : num
  }
  initDate() {
    this.fullYear = this._date.getFullYear()
    this.month = this._date.getMonth() + 1
    this.date = this._date.getDate()
    this.hours = this._date.getHours()
    this.minutes = this._date.getMinutes()
    this.seconds = this._date.getSeconds()
  }
}
export default function (date, format) {
  const df = new DateFormat(date)
  df.initDate()
  masks.forEach(function(value, key) {
    if(format.includes(key)) {
      let formatTime = key.length > 1 ? df.formatNumber(df[value]) : df[value]
      format = format.replace(key, formatTime)
    }
  })
  return format;
}
